namespace $ {

	export class $shm_pb extends $shm_pocketbase_client {

		static override storage_prefix() {
			return 'hitalama_ba'
		}

		static override url_store_key() {
			return 'hitalama_ba_pb_url'
		}

		static override default_url() {
			const location = $mol_dom_context.location
			const host = location.host

			if( host.startsWith( 'dashboard.' ) ) {
				return `${ location.protocol }//pb.${ host.slice( 10 ) }`
			}

			if( host.startsWith( 'ba.' ) ) {
				return `${ location.protocol }//pb.${ host.slice( 3 ) }`
			}

			return 'https://pb.shmakov.media'
		}

	}

}
